import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Tooltip, Legend, Cell } from 'recharts';

const PaiChartGraphReview = ({ reviews }) => {
  const [pieChartData, setPieChartData] = useState([]);

  useEffect(() => {
    if (reviews && reviews.length > 0) {
      const data = reviews.map(item => ({
        name: `☆ Rating ${item.rating} (${item.percent}%)`,
        title: `${item.percent}%`,
        value: parseFloat(item.percent),
      }));
      setPieChartData(data);
    }
  }, [reviews]);

  const colors = [
    '#2C3E50', '#1ABC9C', '#E74C3C', '#3498DB', '#F39C12',
    '#8E44AD', '#16A085', '#F4A261', '#2ECC71', '#95A5A6',
  ];

  // Label rendered outside the slice
  const renderCustomizedLabel = ({
    cx, cy, midAngle, innerRadius, outerRadius, index
  }) => {
    const RADIAN = Math.PI / 180;
    const labelOffset = 20; // distance outside the pie
    const x = cx + (outerRadius + labelOffset) * Math.cos(-midAngle * RADIAN);
    const y = cy + (outerRadius + labelOffset) * Math.sin(-midAngle * RADIAN);

    const item = pieChartData[index];

    return (
      <g>
        {/* Connector line */}
        <line
          x1={cx + outerRadius * Math.cos(-midAngle * RADIAN)}
          y1={cy + outerRadius * Math.sin(-midAngle * RADIAN)}
          x2={x - (x > cx ? 5 : -5)}
          y2={y}
          stroke="#555"
          strokeWidth={1.5}
        />
        {/* Text label */}
        <text
          x={x}
          y={y}
          fill="#000"
          textAnchor={x > cx ? 'start' : 'end'}
          dominantBaseline="central"
          fontSize="12"
          fontWeight="bold"
        >
          {item.title}
        </text>
      </g>
    );
  };

  return (
    <div style={{ textAlign: 'center' }}>
      {pieChartData.length > 0 ? (
        <PieChart width={420} height={400}>
          <Pie
            data={pieChartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={100}
            outerRadius={150}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            {pieChartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value, name) => [name]} />
          <Legend />
        </PieChart>
      ) : (
        <div>No charts</div>
      )}
    </div>
  );
};

export default PaiChartGraphReview;
